import React from 'react'

const WebViewFailed = () => {
  return (
    <div></div>
  )
}

export default WebViewFailed